import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ArmaPc } from '@core/models/ArmaPc';
import { CoolerCpu, Mother } from '@core/services/CompatibilityHandler/model';
import { ProductFactory } from '@core/services/CompatibilityHandler/ProductFactory.service';
import { ProductInCompatibility } from '@core/services/CompatibilityHandler/productInCompatibility';
import { PiramidalService } from '@core/services/piramidal.service';
import { environment } from '@environments/environment';
import { BehaviorSubject, forkJoin, from, Observable, of, Subject } from 'rxjs';
import { ignoreElements, tap } from 'rxjs/operators';
import { ProductIndex } from './ProductIndex';
import { CARACTERISTICAS_FUENTE_KIT } from './caracteristicasFuenteKit';

interface ProductosIncompatibles {
  [x: number]: { idProducto: number; observacion: string };
}

@Injectable({
  providedIn: 'root',
})
export class ArmaPcDataService {
  private products: ArmaPc = new ArmaPc();
  private productsIndex: ProductIndex = {};
  private obtenerProductos = new BehaviorSubject<ArmaPc>(null);
  obtenerProductos$ = this.obtenerProductos.asObservable();
  private obtenerProductosIndex = new Subject<ProductIndex>();
  obtenerProductosIndex$ = this.obtenerProductosIndex.asObservable();
  private loadingArmado = new BehaviorSubject({ estado: true, final: null });
  loadingArmado$ = this.loadingArmado.asObservable();
  //PRODUCTOS INCOMPATIBLES
  private productosIncompatibles: Array<any>;
  public obtenerProductosIncompatibles = new BehaviorSubject<ProductosIncompatibles[]>([]);
  obtenerProductosIncompatibles$ = this.obtenerProductosIncompatibles.asObservable();

  // agregar el agrupador 'extras' cuando retorne productos del piramidal
  private camposPerifericos = [
    'coolerfan',
    'mouse',
    'mousepad',
    'teclados',
    'auriculares',
    'soportes',
    'extras',
  ];
  private nombreAgrupador: string;
  private cambioNombreAgrupador = {
    mothers: 'mother',
    coolercpu: 'ccpu',
  };
  constructor(
    private http: HttpClient,
    private piramidalService: PiramidalService,
    private productFactory: ProductFactory,
  ) {
    this.getDataArmaPc();
  }

  getDataArmaPc() {
    const caracteristicasTotales$ = this.http.get(
      `${environment.apiStatic}armado_pc_caracteristicas`,
    );
    const productosExcluidos: number[] = [8451];
    const prodIncompatibles$ = this.http.get(`${environment.apiStatic}productosIncompatibles`);
    forkJoin([
      caracteristicasTotales$,
      this.piramidalService.products.observable,
      prodIncompatibles$,
    ])
      .pipe(
        tap((res: any) => {
          let caracteristicas = res[0];
          this.productosIncompatibles = res[2];
          Object.keys(caracteristicas).forEach((k, i) => {
            this.nombreAgrupador = this.cambioNombreAgrupador[k] ?? k;
            this.productsIndex[this.nombreAgrupador] = {};

            this.products[this.nombreAgrupador] = caracteristicas[k].reduce((array, item) => {
              if (productosExcluidos.includes(item['id_producto'])) return array;
              if (item && item['id_producto']) {
                if (!this.piramidalService.products.cache[item['id_producto']]) return array;
                if (item['id_fuente'] > 0) {
                  item['$caracteristicas_fuente'] = {
                    $caracteristicas: CARACTERISTICAS_FUENTE_KIT,
                  };
                }
                if (item.id_producto == 2093 || item.id_producto == 2094) {
                  this.piramidalService.products.cache[item['id_producto']] = new CoolerCpu(
                    this.piramidalService.products.cache[item['id_producto']],
                  );
                } else {
                  this.piramidalService.products.cache[item['id_producto']] =
                    this.productFactory.crearPorSubcategoria(
                      this.piramidalService.products.cache[item['id_producto']],
                    );
                }

                let producto = new ProductInCompatibility(
                  this.piramidalService.products.cache[item['id_producto']],
                );
                producto.product.$caracteristicas = item;
                this.productsIndex[this.nombreAgrupador][item.id_producto] = producto;

                array.push(producto);

                return array;
              } else {
                return array;
              }
            }, []);
          });

          this.products.perifericos = [];
          this.camposPerifericos.forEach((agrupador) => {
            this.products.perifericos = [...this.products.perifericos, ...this.products[agrupador]];
            this.productsIndex.perifericos = {
              ...this.productsIndex.perifericos,
              ...this.productsIndex[agrupador],
            };
          });

          this.obtenerProductosIncompatibles.next(this.productosIncompatibles);
          this.obtenerProductos.next(this.products);
          this.obtenerProductosIndex.next(this.productsIndex);
          this.cancelLoading();
        }),
      )
      .subscribe(
        () => {},
        (err) => {
          this.loadingArmado.next({ estado: false, final: 'error' });
        },
      );
  }
  startLoading() {
    this.loadingArmado.next({ estado: true, final: null });
  }
  cancelLoading() {
    this.loadingArmado.next({ estado: false, final: 'data' });
  }
}
